import api from 'utils/resources/utils.api';
import actionTypes from './action-types';

export const fetchRetailerDetailsRequest = () => ({
  type: actionTypes.FETCH_RETAILER_DETAILS_REQUEST,
});

export const fetchRetailerDetailsSuccess = (details) => ({
  type: actionTypes.FETCH_RETAILER_DETAILS_SUCCESS,
  details,
});

export const fetchRetailerDetailsFailure = () => ({
  type: actionTypes.FETCH_RETAILER_DETAILS_FAILURE,
});

export const fetchRetailerDetails =
  (retailerId = null) =>
  async (dispatch, getState) => {
    try {
      const { session } = getState();
      const id = retailerId || session.retailer.retailerId;
      if (!id) return;
      dispatch(fetchRetailerDetailsRequest());

      const details = await api.fetchRetailerDetails(id);

      dispatch(fetchRetailerDetailsSuccess(details));
    } catch (error) {
      console.error('FETCH_RETAILER_DETAILS', error);
      dispatch(fetchRetailerDetailsFailure());
    }
  };

export const clearRetailerDetails = () => ({
  type: actionTypes.CLEAR_RETAILER_DETAILS,
});



// WEBPACK FOOTER //
// ./src/modules/utils/actions/utils.actions.js